import { render, staticRenderFns } from "./dSocialAutorsBar.vue?vue&type=template&id=369943df&"
import script from "./dSocialAutorsBar.vue?vue&type=script&lang=js&"
export * from "./dSocialAutorsBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports